import utils from "../../../utils/utils";

// Operasyon sayfası açılışta kuyrukları checkuserlogoff ile paralel çeker; aktif bileşen bu sonucu bir kez kullanır.
const QUEUE_PREFETCH_MAX_AGE_MS = 10000;
let queuePrefetch = null;

export default {
    prefetchQueues() {
        const promise = utils.utility.fetch("api/editor/getuserqueues", "GET", null, null);
        promise.catch(() => {});

        queuePrefetch = { promise, time: Date.now() };
    },
    clearQueuePrefetch() {
        queuePrefetch = null;
    },
    async fetchQueues(context) {
        const prefetch = queuePrefetch;
        queuePrefetch = null;

        let responseData = null;

        if (prefetch && Date.now() - prefetch.time < QUEUE_PREFETCH_MAX_AGE_MS) {
            responseData = await prefetch.promise.catch(() => null);
        }

        if (!responseData) {
            responseData = await utils.utility.fetch("api/editor/getuserqueues", "GET", null, null);
        }

        context.commit("setQueues", responseData.data);
    },
    async putQueues(context, payload) {
        let selectedQueues = payload.selectedQueues.map((queue, index) => { return { ...queue, order: index + 1 }});
        let data = selectedQueues.map((queue, index) => ({ queueId: queue.id, sortNumber: index + 1 }));  

        await utils.utility.fetch("api/editor/setuserqueues", "POST", null, { queues:data });

        payload.selectedQueues = selectedQueues;
               
        context.commit("setQueues", payload);
    },
    async resetQueues(context) {
        await utils.utility.fetch("api/editor/resetuserqueues", "PUT", null, null);

        const responseData = await utils.utility.fetch("api/editor/getuserqueues", "GET", null, null);

        context.commit("setQueues", responseData.data);
    },
    async fetchQueueUsers(context, payload) {
        const queueId = payload.queueId;

        const response = await utils.utility.fetch(`api/Editor/GetQueueUsers?QueueId=${queueId}`, "GET", null, null);
        
        context.commit("setQueueUsers", response.data);
    },
    async fetchLiveFeedCounts(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);

        const response = await utils.utility.fetch(`api/Editor/GetLiveFeedCountPerQueue?${queryParameters.toString()}`, "GET", null, null, true);
        
        context.commit("setLiveFeedCounts", response.data);
    },
    async fetchQueueStats(context, payload) {       
        const response = await utils.utility.fetch(`api/Editor/GetEngagementStats?QueueId=${payload.queueId}`,"GET",null,null,true);
        
        context.commit("setStats", response.data);
    }
}